var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverItemIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 25L18.3333 28.3333L25 21.6667M21.6667 5.00145C21.5075 5 21.3288 5 21.1245 5H13.667C11.8002 5 10.866 5 10.153 5.36331C9.52579 5.68289 9.01622 6.19245 8.69664 6.81966C8.33333 7.5327 8.33333 8.46682 8.33333 10.3337V29.667C8.33333 31.5338 8.33333 32.4668 8.69664 33.1798C9.01622 33.807 9.52579 34.3175 10.153 34.637C10.8653 35 11.7983 35 13.6616 35L26.3385 35C28.2017 35 29.1333 35 29.8457 34.637C30.4729 34.3175 30.9841 33.807 31.3037 33.1798C31.6667 32.4675 31.6667 31.5358 31.6667 29.6726V15.5428C31.6667 15.3383 31.6666 15.1593 31.6651 15M21.6667 5.00145C22.1427 5.00578 22.4439 5.02308 22.7314 5.0921C23.0715 5.17376 23.3964 5.30877 23.6947 5.49154C24.0309 5.69761 24.3197 5.98636 24.8958 6.5625L30.105 11.7716C30.6815 12.3481 30.9681 12.6356 31.1743 12.972C31.357 13.2702 31.4922 13.5954 31.5739 13.9355C31.6429 14.2229 31.6606 14.5242 31.6651 15M21.6667 5.00145V9.66667C21.6667 11.5335 21.6667 12.4663 22.03 13.1793C22.3496 13.8065 22.8591 14.3175 23.4863 14.637C24.1987 15 25.1317 15 26.9949 15H31.6651M31.6651 15H31.667",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverItemIcon3);
export default __webpack_public_path__ + "static/media/discoverItemIcon3.2476f43a1ee531f70a73052113ce8dc0.svg";
export { ForwardRef as ReactComponent };